<div
  [ngClass]="{
    warning: type === 'warn' || 'warn-soft',
    info: type === 'info',
    border: type !== 'warn-soft',
    error: type === 'error'
  }"
  class="container"
>
  <div class="message">
    <mat-icon class="icon">{{ icon }}</mat-icon>
    <span [innerHTML]="statusText | translate"></span>
  </div>
  <div class="action" *ngIf="actionTitle && actionCallback">
    <a *ngIf="buttonType === 'link'" (click)="actionCallback()">
      {{ actionTitle }}
    </a>
    <button
      mat-raised-button
      *ngIf="buttonType === 'button'"
      color="primary"
      (click)="actionCallback()"
    >
      {{ actionTitle }}
    </button>
  </div>
</div>
